import React from 'react';
import PropTypes from 'prop-types';
import { Viewer } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import classes from './Viewer.module.scss';

const PDFViewer = ({ fileUrl, options = {} }) => {
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

  return (
    <div className={classes.pdf}>
      <div className={classes.toolbar}>
        <ZoomOutButton />
        <ZoomPopover />
        <ZoomInButton />
      </div>
      <div
        className={classes.viewer}
        style={{
          flexGrow: 1,
        }}>
        <Viewer fileUrl={fileUrl} plugins={[zoomPluginInstance]} defaultScale={1} {...options} />
      </div>
    </div>
  );
};
PDFViewer.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  options: PropTypes.object,
};

PDFViewer.defaultProps = {
  options: {},
};

export default PDFViewer;
